export const EXCLUDE_IN_BOM = [
    "Family Type",
    "Family Name"
]